import { PayloadAction } from "@reduxjs/toolkit";
import { CartSliceState } from "../types";

export const paginationReducers = {
  setProductionOrder: (
    state: CartSliceState,
    action: PayloadAction<{ type: "asc" | "desc"; field: string }>,
  ) => {
    state.productionOrder = action.payload;
  },
  setRemainsOrder: (
    state: CartSliceState,
    action: PayloadAction<{ type: "asc" | "desc"; field: string }>,
  ) => {
    state.remainsOrder = action.payload;
  },
  setProductionPageSize: (
    state: CartSliceState,
    action: PayloadAction<number>,
  ) => {
    state.productionPageSize = action.payload;
  },
  setRemainsPageSize: (
    state: CartSliceState,
    action: PayloadAction<number>,
  ) => {
    state.remainsPageSize = action.payload;
  },
  setProductionPageNumber: (
    state: CartSliceState,
    action: PayloadAction<number>,
  ) => {
    state.productionPageNumber = action.payload;
  },
  setRemainsPageNumber: (
    state: CartSliceState,
    action: PayloadAction<number>,
  ) => {
    state.remainsPageNumber = action.payload;
  },
  setDealerRemainsPageSize: (
    state: CartSliceState,
    action: PayloadAction<number>,
  ) => {
    state.dealerRemainsPageSize = action.payload;
  },
  setDealerRemainsPageNumber: (
    state: CartSliceState,
    action: PayloadAction<number>,
  ) => {
    state.dealerRemainsPageNumber = action.payload;
  },
  setProductionDefaultOrder: (
    state: CartSliceState,
    action: PayloadAction<{ type: "asc" | "desc"; field: string }>,
  ) => {
    state.productionDefaultOrder = action.payload;
  },
  setRemainsDefaultOrder: (
    state: CartSliceState,
    action: PayloadAction<{ type: "asc" | "desc"; field: string }>,
  ) => {
    state.remainsDefaultOrder = action.payload;
  },
};
